module.exports = __webpack_public_path__ + "img/java.b25fb293.png";